import { DecoratedFormProps, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { Dispatch } from 'react';
import {
    email,
    maxLength,
    minPhoneLength,
    minLength,
    required,
    Validators,
} from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from '../assets/agency-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from 'connected-react-router';
import { toast } from 'react-toastify';
import { asyncPersistAgency } from 'src/store/actions/app-actions';
import { IAgencyInfo } from 'src/types/app';
import { FieldInputMask } from 'src/components/redux-form/fields/FieldInputMask';
import Loader from '../../../../../components/Loader';
import { DropZoneField } from '../../../../../components/DropZoneField';
export interface AgencyFormData extends Partial<IAgencyInfo> {}
interface AgencyFormProps extends Partial<IAgencyInfo> {
    files: any;
    logoDoc: any;
    miniLoaderFor: { [key: string]: boolean };
    handeAdd: (file: any) => any;
}

type InjectedProps = InjectedFormProps<AgencyFormData, AgencyFormProps>;

const validators: Validators<AgencyFormData> = {
    name: [required({ message: 'Name is required.' }), maxLength({ max: 255 })],
    suffix: [maxLength({ max: 255 })],
    addressTwo: [maxLength({ max: 255 })],
    phone: [required({ message: 'Phone is required.' }), minPhoneLength({ min: 12 })],
    email: [required({ message: 'Email is required.' }), email(), minLength({ min: 1 }), maxLength({ max: 255 })],
    snn: [required({ message: 'EIN # / SSN # is required.' }), maxLength({ max: 255 })],
    address: [required({ message: 'Address is required.' }), maxLength({ max: 255 })],
    taxId: [required({ message: 'Tax Id required.' }), maxLength({ max: 255 })],
    exigentHours: [],
    exigentAmount: [],
};

const AgencyForm: React.FunctionComponent<InjectedProps & AgencyFormProps> = ({
    handleSubmit,
    initialValues,
    error,
    logoDoc,
    files,
    handeAdd,
    miniLoaderFor,
    dirty,
    submitting,
}: InjectedProps & AgencyFormProps) => {
    const logoDocs = [];
    if (logoDoc) {
        const signDocFile = {
            attach: logoDoc,
            mimeType: initialValues.logoDocMimeType,
            name: initialValues.logoDocName,
        };
        logoDocs.push(signDocFile);
    }

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldInput
                name="name"
                type="text"
                validate={validators.name}
                wrapperConfig={{
                    label: 'Name *',
                }}
            />
            <FieldInput
                name="suffix"
                type="text"
                validate={validators.suffix}
                wrapperConfig={{
                    label: 'Suffix',
                }}
            />

            <FieldInput
                name="snn"
                type="text"
                validate={validators.snn}
                wrapperConfig={{
                    label: 'EIN # / SSN # *',
                }}
            />

            <FieldInput
                name="address"
                type="text"
                validate={validators.address}
                wrapperConfig={{
                    label: 'Address *',
                }}
            />
            <FieldInput
                name="addressTwo"
                type="text"
                validate={validators.addressTwo}
                wrapperConfig={{
                    label: 'address 2',
                }}
            />

            <FieldInput
                name="email"
                type="text"
                validate={validators.email}
                wrapperConfig={{
                    label: 'Email *',
                }}
            />

            <FieldInputMask
                mask={'999 999 9999'}
                name="phone"
                type="phone"
                validate={validators.phone}
                wrapperConfig={{
                    label: 'Phone Number *',
                }}
            />

            <FieldInput
                name="exigentHours"
                type="text"
                validate={validators.exigentHours}
                wrapperConfig={{
                    label: 'Exigent Bonus Hours Limit *',
                }}
            />

            <FieldInput
                name="exigentAmount"
                type="text"
                validate={validators.exigentAmount}
                wrapperConfig={{
                    label: 'Exigent Bonus Sum *',
                }}
            />

            {/* <FieldInput
                name="taxId"
                type="text"
                validate={validators.taxId}
                wrapperConfig={{
                    label: 'Tax ID *',
                }}
            />*/}
            <div className={'position-relative'}>
                {miniLoaderFor['FILE_AGENCY'] ? <Loader noFull={true} /> : null}
                <div>
                    <div>Agency Logo:</div>
                    <DropZoneField
                        validatePhoto={true}
                        single={true}
                        files={files.length ? files : logoDocs}
                        setFiles={handeAdd}
                    />
                </div>
            </div>

            <div className={classNames(styles.actions)}>
                <button
                    type="submit"
                    className={classNames('btn', 'btn-success', 'mr-3')}
                    disabled={!dirty || submitting}
                >
                    <FontAwesomeIcon icon={faSave} /> {'Update'}
                </button>
                <Link className={classNames('btn', 'btn-danger')} to={Router.generate(routes.PROVIDERS_LIST)}>
                    <FontAwesomeIcon icon={faBan} /> Cancel
                </Link>
            </div>
        </form>
    );
};
export default reduxForm<AgencyFormData, AgencyFormProps>({
    form: 'agency-form',
    onSubmit: asyncPersistAgency,
    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<AgencyFormData, AgencyFormProps, string>,
    ) {
        toast.success(`Agency was successfully updated`);
        dispatch(push(Router.generate(routes.AGENCY_INFO, { type: 'info' })));
    },
})(AgencyForm);
